import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}

export const actions = {
  async getAllExceptions(
    { commit },
    { pageSize, pageNumber, key, value, sortBy, sortDirection }
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.getAllExceptions}?PageSize=${pageSize}&PageNumber=${pageNumber}&Key=${key}&Value=${value}&SortBy=${sortBy}&SortDirection=${sortDirection}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },

  async getAllSourceTypes({ commit }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.getAllSourceTypes}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },

  async createException({ commit }, exception) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.createException}`,
        exception,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },

  async updateException({ commit }, exception) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.updateException}`,
        exception,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },

  async getSupportEmailId({ commit }) {
    return axios
      .get(`${appConfig.apiEndPoint}${endpoint.adminApiPath.getSupportEmail}`, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error.response
      })
  },

  async updateSupportEmailId({ commit }, emailID) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.updateSupportEmail}`,
        {
          Value: emailID,
        },
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        return error.response
      })
  },
}
